import { CARE_OF_KINDS, type SourcingOption, type Supplier } from '@/api/sourcing'
import type { PurchaseOrderDetail } from './types'

/**
 * The distributor or retailer the PO is bought through. Right after a change the PO's loaded
 * source is the previous one, so the manufacturer's sources answer until the PO reloads.
 */
export function careOfSupplier(
  po: PurchaseOrderDetail,
  options: readonly SourcingOption[],
): Supplier | null {
  const chosen = po.source?.sourcing_option_id
  const source =
    po.source?.sourcing_option?.id === chosen
      ? po.source?.sourcing_option
      : options.find((option) => option.id === chosen)
  const supplier = source?.supplier ?? null
  return supplier && CARE_OF_KINDS.has(supplier.kind) ? supplier : null
}
